<template>
  <div class="container-fluid autenticacao">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">Autenticidade de Notas Fiscais</h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          <div class="form-title-links">
            <span class="form-title"
              >Informe aqui a chave de validação para autenticação da Nota Fiscal /
              {{ notaTomador ? 'Nota Tomador' : 'DAPS' }} / Nota Fiscal Avulsa</span
            >
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-5 col-lg-4 mb-3">
            <div>
              <RadioButton
                inputId="radio1"
                name="documento"
                value="N"
                v-model="tipoValidacao"
                class="radio"
                tabindex="1"
              />
              <label for="radio1">NFS-e/Avulsa</label>
              <RadioButton
                inputId="radio2"
                name="chave"
                value="D"
                v-model="tipoValidacao"
                class="radio2"
                tabindex="2"
              />
              <label for="radio2">{{ notaTomador ? 'Nota Tomador' : 'DAPS' }}</label>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-2 col-lg-3 mb-3 links-tipoPessoa">
            <label for="tipoPessoa">Tipo: </label>
            <span class="p-fluid">
              <Dropdown
                id="tipoPessoa"
                v-model="selectedTipoPessoa"
                :options="tiposPessoa"
                optionLabel="name"
                placeholder="Selecione um Tipo de Pessoa"
              />
            </span>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-2 col-lg-9 mb-3">
            <template v-if="selectedTipoPessoa && selectedTipoPessoa.key === 'F'">
              <InputMask
                id="cpfCnpj"
                type="text"
                placeholder="CPF do prestador"
                autocomplete="off"
                v-model="documentoPrestador"
                mask="999.999.999-99"
                key="F"
                @blur="validarDocumento()"
                tabindex="3"
                class="inputLogin"
              />
            </template>
            <template v-else>
              <InputMask
                id="cpfCnpj"
                type="text"
                placeholder="CNPJ do prestador"
                autocomplete="off"
                v-model="documentoPrestador"
                mask="**.***.***/****-99"
                key="J"
                @blur="validarDocumento()"
                tabindex="3"
                class="inputLogin"
                style="text-transform: uppercase;"
              />
            </template>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-2 col-lg-9 mb-3">
            <InputText
              id="chave"
              type="text"
              placeholder="Chave de Validação"
              autocomplete="off"
              tabindex="4"
              class="inputLogin"
              v-model="chaveValidacao"
              :disabled="disabledChaveValidacao"
              @input="campoInputHandler('chaveValidacao')"
            />
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-2 col-lg-9 mb-3">
            <InputText
              id="numero"
              type="text"
              placeholder="Número"
              autocomplete="off"
              tabindex="4"
              class="inputLogin"
              v-model="numeroNota"
              :disabled="disabledNumeroNota"
              @input="campoInputHandler('numeroNota')"
            />
          </div>
        </div>

        <div class="botoes-avancar-voltar" style="padding-left: 15px;">
          <Button
            label="Voltar"
            type="submit"
            class="btnVoltar"
            id="btnVoltar"
            @click="login()"
            icon="pi pi-angle-left"
            :disabled="loading"
          />
          <Button
            label="Autenticar"
            type="submit"
            class="btnAvançar"
            id="btnAutenticar"
            @click="autenticar()"
            icon="pi pi-angle-right"
            :disabled="loading"
          />
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-md-2 col-lg-9 mb-3">
            <!-- <div class="copyright">©{{ this.anoAtual }} - GPI - Gestão Pública Integrada</div> -->
          </div>
        </div>
      </div>
    </div>
    <Dialog class="test-box" header="Documento válido!" :visible.sync="showDialog" :modal="true" :closable="false">
      <div class="container">
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Deseja visualizar o documento validado?</label>
          </div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row justify-content-between">
          <div>
            <Button
              @click="visualizarDanfse()"
              v-if="this.notaSelecionada && (this.notaSelecionada.transmitidoNacional === 'I' || this.notaSelecionada.transmitidoNacional === 'M')"
              href="#topo"
              type="button"
              label="DANFSE"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
            <Button
              @click="visualizar()"
              v-if="this.notaSelecionada && this.notaSelecionada.transmitidoNacional !== 'I' && this.notaSelecionada.transmitidoNacional !== 'M'"
              href="#topo"
              type="button"
              label="Visualizar"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              v-if="exibirBtnTermo"
              @click="visualisarTermoAutentic()"
              href="#topo"
              type="button"
              label="Termo Autenticação"
              class="p-button-primary mr-2 p-button-primary"
              icon="pi pi-print"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              v-if="exibirBtnXml"
              label="Exportar XML"
              type="submit"
              class="p-button-primary mr-2"
              icon="pi pi-download"
              @click="autenticarXml()"
              :disabled="loading"
            />
          </div>

          <div class="col-auto">
            <Button
              @click="showDialog = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import AutenticacaoService from '../services/nfse/autenticacao.service';
import DnsClienteService from '../services/nfse/dns.cliente.service';
import ReportService from '../services/report.service';
import Util from '../Utils/util';

export default {
  data() {
    return {
      documentoPrestador: null,
      chaveValidacao: null,
      numeroNota: null,
      tipoValidacao: 'N',
      loading: false,
      showDialog: false,
      documentoId: null,
      idCliente: null,
      anoAtual: null,
      notaTomador: false,
      selectedTipoPessoa: null,
      tiposPessoa: [
        { name: 'Pessoa Física', key: 'F' },
        { name: 'Pessoa Jurídica', key: 'J' },
        { name: 'Entidade', key: 'E' },
      ],
      disabledNumeroNota: false,
      disabledChaveValidacao: false,
      exibirBtnXml: false,
      exibirBtnTermo: false,
      notaSelecionada: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const cpfCnpjInput = document.getElementById('cpfCnpj');
      if (cpfCnpjInput) {
        cpfCnpjInput.focus();
      }
    });

    var d = new Date();
    this.anoAtual = d.getFullYear();
    setTimeout(async () => {
      this.processando(true);
      let host = window.location.hostname;
      this.dnsCliente = await DnsClienteService.get(host);
      if (this.dnsCliente && this.dnsCliente.data && this.dnsCliente.data.idCliente) {
        this.idCliente = this.dnsCliente.data.idCliente;
        if ('19533831040781681800D2584C905F8A' === this.idCliente) {
          this.notaTomador = true;
        }
      }
      this.processando(false);
    }, 250);
  },

  created() {
    this.selectedTipoPessoa = this.tiposPessoa[0];
    this.limparDados();
    this.documentoPrestador = this.$route.query.cpfCnpj;
    this.chaveValidacao = this.$route.query.chave;
    this.numeroNota = this.$route.query.numero;

    if (this.documentoPrestador) {
      let numeros = this.documentoPrestador.match(/\d+/g);
      numeros = numeros ? numeros.join('') : '';
      if (numeros.length > 11) {
        this.selectedTipoPessoa = this.tiposPessoa[1];
      } else {
        this.selectedTipoPessoa = this.tiposPessoa[0];
      }
    }
    this.tipoValidacao = this.$route.query.tipo ? this.$route.query.tipo : 'N';
  },

  computed: {
    exibirBotao() {
      return {
        voltar: true,
        avancar: true,
        credenciar: false,
      };
    },
  },

  methods: {
    campoInputHandler(campo) {
      switch (campo) {
        case 'chaveValidacao':
          if (this.chaveValidacao === '') {
            this.disabledNumeroNota = false;
          } else if (this.chaveValidacao !== '') {
            this.disabledNumeroNota = true;
          }
          break;
        case 'numeroNota':
          if (this.numeroNota === '') {
            this.disabledChaveValidacao = false;
          } else if (this.numeroNota !== '') {
            this.disabledChaveValidacao = true;
          }
          break;

        default:
          break;
      }
    },

    limparDados() {
      this.documentoPrestador = null;
      this.chaveValidacao = null;
      this.numeroNota = null;
      this.loading = false;
      this.showDialog = false;
      this.documentoId = '';
    },

    exibirDialog() {
      this.showDialog = true;
    },

    login() {
      this.$router.push('/login');
    },

    autenticar() {
      this.processando(true);
      console.log(this.numeroNota);

      if (this.documentoPrestador && this.tipoValidacao && this.idCliente && (this.chaveValidacao || this.numeroNota)) {
        AutenticacaoService.autenticacao(
          this.idCliente,
          this.tipoValidacao,
          this.documentoPrestador,
          this.chaveValidacao != null ? this.chaveValidacao.trim() : null,
          this.numeroNota != null ? this.numeroNota.trim() : null,
        )
          .then(
            (response) => {
              this.documentoId = response.data.id;
              console.log(response);
              console.log(this.tipoValidacao);

              this.notaSelecionada = response.data;

              if (this.tipoValidacao === 'N') {
                this.exibirBtnXml = true;
                this.exibirBtnTermo = true;
              } else {
                this.exibirBtnXml = false;
                this.exibirBtnTermo = false;
              }
              this.exibirDialog();
              this.$root.$emit('alert:success', 'Documento validado com sucesso!');
            },
            (error) => {
              this.$root.$emit('alert:error', error.response.data);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', 'É necessário preencher todos os campos!');
        this.processando(false);
      }
    },

    autenticarXml() {
      this.processando(true);
      AutenticacaoService.autenticacaoXml(
        this.idCliente,
        this.tipoValidacao,
        this.documentoPrestador,
        this.chaveValidacao != null ? this.chaveValidacao.trim() : null,
        this.numeroNota != null ? this.numeroNota.trim() : null,
      )
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao efetuar o download!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    visualizarDanfse() {
      this.processando(true);

      AutenticacaoService.downloadDanfseHtml(this.notaSelecionada.id)
        .then((response) => {
          const html = response.data;
          ReportService.openHtmlFromBytes(html);
        })
        .catch((error) => {
          this.$root.$emit('alert:warn', 'Erro ao efetuar o download da DANFSE!');
          console.error('Erro ao efetuar o download da DANFSE:', error);
        })
        .then(() => {
          this.processando(false);
        });
    },

    visualizar() {
      this.processando(true);
      console.log(this.numeroNota);
      if (this.documentoPrestador && this.idCliente && (this.chaveValidacao || this.numeroNota)) {
        console.log('aqui');
        AutenticacaoService.visualisar(
          this.idCliente,
          this.tipoValidacao,
          this.documentoPrestador,
          this.chaveValidacao ? this.chaveValidacao : null,
          this.numeroNota ? this.numeroNota : null,
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    visualisarTermoAutentic() {
      this.processando(true);
      console.log(this.documentoId);
      AutenticacaoService.visualisarTermoAutentic(this.documentoId)
        .then(
          () => {},
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.$root.$emit('alert:error', 'CPF/CNPJ inválido!');
      }
    },
  },
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>
